import { render, staticRenderFns } from "./genderPieChart.vue?vue&type=template&id=1171a051"
import script from "./genderPieChart.vue?vue&type=script&lang=js"
export * from "./genderPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports